<template>
  <div v-bind:class="{ 'dispatch-modal': true, show: validationModal.show || actionModal.show }" @click="close">
    <div class="dispatch-modal-container">
      <div class="dispatch-modal-content" @click.stop>
        <div class="validation-modal" v-if="validationModal.show">
          <div class="title">{{ validationModal.title }}</div>
          <div class="message" v-html="validationModal.message"></div>
          <a class="button success" href="javascript:;" @click="close">GOT IT.</a>
        </div>

        <div class="action-modal" v-if="actionModal.show">
          <div v-bind:class="{
              'circle-loader': true,
              'load-complete': actionModal.done && actionModal.success,
              'load-error': actionModal.done && !actionModal.success
            }">
            <div v-bind:class="{
                checkmark: true,
                draw: actionModal.done && actionModal.success,
                'error show': actionModal.done && !actionModal.success
              }"></div>
          </div>
          <div :class="['message', {
            success: actionModal.done && actionModal.success,
            error: actionModal.done && !actionModal.success
          }]">
            <span v-if="actionModal.done" v-html="actionModal.doneMessage"></span>
            <span v-else v-html="actionModal.ongoingMessage"></span>
          </div>
          <div v-if="actionModal.done && actionModal.success" style="margin-top: 30px">
            <a class="button block" href="javascript:;" @click="closeDone">CLOSE</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dispatch-modal',
  computed: {
    validationModal () { return this.$store.state.dispatch.validationModal },
    actionModal () { return this.$store.state.dispatch.actionModal }
  },
  methods: {
    close () {
      this.$store.commit('dispatch/closeValidationModal')
    },
    closeDone () {
      this.$store.commit('dispatch/closeActionModal')
    }
  },
  mounted () {
    let self = this
    document.addEventListener('keydown', (e) => {
      if (self.validationModal.show && e.keyCode == 27) {
        self.$store.commit('dispatch/closeValidationModal')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.dispatch-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.dispatch-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.dispatch-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  // overflow: hidden;  
}

.validation-modal {
  & .title{
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background-color: #F25E0D;
    padding: 8px 15px;
  }

  & .message{
    font-size: 16px;
    font-weight: 700;
    color: #555;
    padding: 15px 15px 10px;
  }

  & .button{
    margin: 10px 15px 15px;
    font-weight: 700;
  }
}

.action-modal{
  padding: 15px;
  & .message{
    font-weight: 700;
    color: #777;
    transition: all 250ms;
    word-wrap: break-word;

    &.success{ color: #26D97A; }
    &.error{ color: #F20D0D; }
  }
}

// Define vars we'll be using
$brand-success: #26D97A;
$loader-size: 50px;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12);
$error-left: $loader-size/4;
$check-thickness: 5px;
$check-color: $brand-success;
$error-color: #F20D0D;

.circle-loader {
  margin: 0 0 10px 10px;
  border: $check-thickness solid rgba(0, 0, 0, 0.2);
  border-left-color: $check-color;
  animation-name: loader-spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  box-sizing: content-box;
}

.circle-loader,
.circle-loader:after {
  border-radius: 50%;
  width: $loader-size;
  height: $loader-size;
}

.load-complete {
  -webkit-animation: none;
  animation: none;
  border-color: $check-color;
  transition: border 500ms ease-out;
}
.load-error {
  -webkit-animation: none;
  animation: none;
  border-color: $error-color;
  transition: border 500ms ease-out;
}

.checkmark {
  opacity: 0;
  box-sizing: content-box;
  &.draw{ opacity: 1; }
  &.draw:after {
    opacity: 1;
    height: $check-height;
    width: $check-width;
    transform-origin: left top;
    border-right: $check-thickness solid $check-color;
    border-top: $check-thickness solid $check-color;
    content: '';
    left: calc(#{$check-left} - 5px);
    top: calc(#{$check-height} + 2px);
    position: absolute;
    animation-duration: 1.2s;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }
  
  &.error {
    position: absolute;
    left: calc(#{$error-left} - 2px);
    top: $error-left;
    width: $loader-size/2;
    height: $loader-size/2;
    opacity: 0;
    &.show{ opacity: 1; }
    &:before, &:after {
      position: absolute;
      content: ' ';
      height: $loader-size/2;
      width: 5px;
      background-color: #f00;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

}
@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dispatch/DispatchModal.vue